// extracted by mini-css-extract-plugin
export default {"wrapper":"sB-z","viewport":"tB-z","container":"uB-z","slide":"vB-z"};